import { parseApiErrorMessage } from "@/lib/api-error-message";

class MockRouteError extends Error {
  constructor(
    message: string,
    public status: number
  ) {
    super(message);
    this.name = "ApiError";
  }
}

/** Same-origin base for Next.js mock API route handlers (port 3000). */
export function mockAppOrigin(): string {
  if (typeof window !== "undefined") return "";
  return process.env.MOCK_APP_ORIGIN ?? "http://localhost:3000";
}

export async function mockAppRequest<T>(
  path: string,
  options?: RequestInit & { token?: string }
): Promise<T> {
  const headers: Record<string, string> = {
    ...(options?.headers as Record<string, string> | undefined),
  };
  const isFormData = options?.body instanceof FormData;
  if (!isFormData && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (options?.token) {
    headers.Authorization = `Bearer ${options.token}`;
  }

  const res = await fetch(`${mockAppOrigin()}${path}`, {
    ...options,
    headers,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "Request failed");
    throw new MockRouteError(parseApiErrorMessage(text, res.status), res.status);
  }

  if (res.status === 204) {
    return undefined as T;
  }

  return res.json() as Promise<T>;
}
